module.exports = __webpack_public_path__ + "static/media/linges.93556daf.jpg";